import { render, staticRenderFns } from "./ModalPageHierarquiaUnidadeAdministrativa.vue?vue&type=template&id=3db5542a"
import script from "./ModalPageHierarquiaUnidadeAdministrativa.vue?vue&type=script&lang=js"
export * from "./ModalPageHierarquiaUnidadeAdministrativa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports